<template>
  <div>
    <ViewTemplateConfiguration :templateList="templateList" :actions="actions">
      <div slot="content-buttons">
        <Button _key="btnBankAccountCreate" title="Conta Bancária" classIcon="fas fa-plus-circle" type="primary"
          size="small" :clicked="create" />
      </div>
    </ViewTemplateConfiguration>
  </div>
</template>

<script>
import ViewTemplateConfiguration from "@nixweb/nixloc-ui/src/component/template/ViewTemplateConfiguration";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";

import { mapMutations } from "vuex";

export default {
  name: "BankAccountView",
  components: {
    ViewTemplateConfiguration,
    Button,
  },
  data() {
    return {
      templateList: {
        urlGetApi: "/api/v1/finance/bank-account/get-all",
        urlDeleteAllApi: "/api/v1/finance/bank-account/delete",
        headerTable: [
          {
            field: "logoHtml",
            type: "html",
            styleBody: "width: 20px;",
          },
          {
            field: "bankName",
            fieldSecond: "fullName",
            title: "Conta",
            type: "link",
            iconSearch: true,
            classCssBody: "center-vertical-bank",
            routeName: "bankAccountUpdate",
          },
          {
            field: "openingBalanceHtml",
            title: "Saldo Inicial",
            type: "html",
            classCssTitle: "text-center",
            classCssBody: "center-vertical-bank text-center",
          },
          {
            field: "accountBalanceHtml",
            title: "Saldo Atual",
            type: "html",
            classCssTitle: "text-center",
            classCssBody: "center-vertical-bank text-center",
          },
          /*   {
               field: "isPluggyConnected",
               title: "Open Finance",
               classCssTitle: "text-center",
               classCssBody: "center-vertical-bank text-center",
               type: "html",
               iconSearch: false,
             },*/
        ],
      },
      actions: [
        { type: "delete", title: "Remover", description: "Remover", url: "/api/v1/finance/bank-account/delete", method: "delete", },
      ],
    };
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
    create() {
      this.$router.push({
        name: "bankAccountCreate",
      });
      this.removeLoading(["btnBankAccountCreate"]);
    },
  },
};
</script>

<style>
.box-user {
  width: 10px;
  height: 10px;
  border-radius: 50px;
  margin-right: 8px;
}

.disconnected {
  background-color: red;
}

.connected {
  background-color: #0A36DB;
}

.img-logo-bank {
  width: 45px;
  height: 45px;
  border-radius: 50px;
}

.badge-account {
  padding: 3px 10px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 400;
  width: 60px;
  margin: auto;
}

.value-nagative {
  background: #fef2f2;
  border: 1px solid #fee2e2;
  color: #ef4444;
}

.value-positive {
  background: #ECFDF5;
  border: 1px solid #d1fae5;
  color: #0D772F;
}
</style>